import { domain } from 'modules/data';

export const getNetSuiteIntegrationCodeByLineReportType = (reportCode: domain.ReportCode | null) => {
    switch (reportCode) {
        case domain.ReportCode.NetSuiteVendorBillItemLine:
            return domain.IntegrationCode.NetSuiteBill;

        case domain.ReportCode.NetSuiteVendorBillExpenseLine:
            return domain.IntegrationCode.NetSuiteBill;

        default:
            return null;
    }
};
